import { ShieldCheck } from "lucide-react";
import { Page, Section } from "@/components/Page";
import { InsuranceSection } from "@/components/InsuranceSection";

export default function Insurance() {
  return (
    <Page data-testid="insurance-page">
      <Section
        className="pt-14 sm:pt-16"
        eyebrow="Health Insurance"
        title="Explore health insurance plans for your family"
        subtitle="Confused about which cover fits you best? Share a few details and an Apnicare advisor will help you compare family floater and individual plans, find cashless network hospitals near you, and guide you through claims and renewals — completely free."
      >
        <div className="inline-flex items-center gap-2 rounded-full bg-sky-50 text-[#0284C7] border border-sky-100 px-3 py-1.5 text-xs font-bold mb-2">
          <ShieldCheck size={13} /> Unbiased, no-obligation guidance
        </div>
      </Section>
      <InsuranceSection />
    </Page>
  );
}
